import { createStore, createLogger } from 'vuex'
import loading from './modules/loading'
import menu from './modules/menu'
import user from './modules/user'
import department from './modules/department'
import dictionary from './modules/dictionary'
import role from './modules/role'
import cookie from "@/store/modules/cookie";

const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    modules: {
        loading,
        menu,
        cookie,
        user,
        department,
        dictionary,
        role,
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
